import { Option } from '../types/data';

import { objEntries } from './object';

export function createOptionsFromMap<T extends string | number>(map: Record<T, string>): Array<Option<T>> {
    return objEntries(map).map(([id, value]) => ({ id, value }));
}
